export default __webpack_public_path__ + "static/media/radio.bb8bdcd7.svg";